/** @format */

import { type ChangeEvent, type KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import search from '../../assets/icon/search.svg';

type SearchProps = {
  keyword?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit?: () => void;
};

export const Search = ({ keyword = '', onChange = () => {}, onSubmit = () => {} }: SearchProps) => {
  const { t } = useTranslation();

  const handleOnKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === 'NumpadEnter') {
      onSubmit();
    }
  };
  return (
    <div className="search-component">
      <input
        value={keyword}
        onChange={onChange}
        onKeyDown={handleOnKeyDown}
        className="search-component-input"
        placeholder={t('searchPage.searchPlaceholder')}
      />
      <button onClick={onSubmit} className="search-component-button">
        <img alt="search button" src={search} />
      </button>
    </div>
  );
};
